import { rem } from 'polished';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const MenuLink = styled(NavLink)<{
  $isInFooter?: boolean;
  $isSelected?: boolean;
}>`
  text-decoration: none;
  display: flex;
  flex-direction: ${({ $isInFooter }) => ($isInFooter ? 'column' : 'row')};
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  width: ${({ $isInFooter }) => ($isInFooter ? 'auto' : '100%')};
  border-radius: ${rem(8)};
  position: relative;
  padding: ${rem(8)} ${rem(12)};
  transition: background-color 0.2s ease;
  background-color: ${({ theme, $isSelected }) =>
    $isSelected
      ? theme.colors.mainNavigation.tab.active.background
      : theme.colors.background.card};

  color: ${({ theme, $isSelected }) =>
    $isSelected
      ? theme.colors.mainNavigation.tab.active.text
      : theme.colors.mainNavigation.tab.inactive.text};

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 4px;
  }

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.mainNavigation.tab.active.background};
    color: ${({ theme }) => theme.colors.mainNavigation.tab.active.text};
  }

  &&:focus,
  &&:focus-visible {
    color: ${({ theme }) => theme.colors.mainNavigation.tab.active.text};
  }
`;

export default MenuLink;
